import { TransactionAdjustmentComponent } from "../../components";

export default function TransactionAdjustmentPage() {
  return <TransactionAdjustmentComponent.TransactionAdjustmentList />;
}
